import { apiV2Root } from "consts";
import { useDataQueryParams } from "hooks/useDataQueryParams";

type EventPageConfig = {
  menuSlug: string | null;
  showComments: boolean;
  showFooter: boolean;
  footerKind: string | null;
  footerText: string;
};

type EventRegistration = {
  id: number;
  title: string;
  registrationLink: string;
  pageConfig: EventPageConfig | null;
};

export const useEventRegistration = (
  eventId: string | undefined,
): EventRegistration | undefined =>
  useDataQueryParams<EventRegistration>(
    `events/${eventId}/registration/`,
    {},
    apiV2Root,
    !eventId,
  );
